export default {
  name: 'transaction_tax_receipt',
  component_path: 'modules/procedures/blocks/transaction/BlockTransactionTaxReceiptRequested'
}